import React from "react";
import { MdArrowBack, MdBolt } from "react-icons/md";
import ProductCard from "../../components/ProductCard";

const FlashSalePage = ({ flashSaleProducts, backToHome, openProduct }) => (
  <main className="page-container">
    <button className="back-link page-back" type="button" onClick={backToHome}>
      <MdArrowBack /> Kembali ke Beranda
    </button>
    <section className="flash-all-panel">
      <div className="flash-all-title">
        <MdBolt /> Semua Produk Flash Sale
      </div>
      <div className="flash-all-grid">
        {flashSaleProducts.map((barang) => (
          <ProductCard barang={barang} key={barang.id} onOpen={openProduct} />
        ))}
      </div>
    </section>
  </main>
);

export default FlashSalePage;
